module.exports = __webpack_public_path__ + "static/img/groundincease2.316e8647.png";